// extracted by mini-css-extract-plugin
export var brand = "_78-9";
export var compact = "_78-6";
export var extraSmall = "_78-7";
export var icon = "_78-0";
export var large = "_78-4";
export var light = "_78-1";
export var medium = "_78-5";
export var outline = "_78-b";
export var primaryDark = "_78-a";
export var primaryLight = "_78-8";
export var primaryModern = "_78-c";
export var success = "_78-2";
export var successSolid = "_78-3";